export function applyLogoInputSelection(
  event: Event,
  apply: (file: File | null, previewUrl: string | null) => void,
): void {
  const input = event.target as HTMLInputElement;
  if (!input.files || input.files.length === 0) {
    apply(null, null);
    return;
  }

  const file = input.files[0];
  const reader = new FileReader();
  reader.onload = () => {
    apply(file, reader.result as string);
  };
  reader.readAsDataURL(file);
}
